import { CheckCircle } from '@phosphor-icons/react';

type RfcPrefillHintProps = {
	/** RFC con el que se prellenó el campo ('' si no hubo prellenado). */
	prefilledRfc: string;
	/** `verified` | `unverified`; cualquier otro valor no pinta nada. */
	status: string;
	/** Lo que el campo muestra ahora. */
	value: string;
};

/**
 * Leyenda bajo el campo de RFC prellenado. Solo se pinta mientras el campo
 * conserve el RFC prellenado: si el usuario lo cambia, la leyenda ya no
 * describe lo que está escrito.
 *
 * Vive en components/molecules porque la comparten el formulario de
 * vinculación (sat-connection) y la pantalla pura `sat-ciec` de onboarding v3,
 * que solo puede importar de esta allowlist (purity.test.ts).
 */
const RfcPrefillHint = ({ prefilledRfc, status, value }: RfcPrefillHintProps) => {
	if (!prefilledRfc || value !== prefilledRfc) return null;
	if (status === 'verified') {
		return (
			<span className='text-h-success-50 -mt-1 flex items-center gap-1 text-xs font-medium'>
				<CheckCircle weight='fill' size={14} />
				Verificado con el SAT
			</span>
		);
	}
	if (status === 'unverified') {
		return (
			<span className='text-h-text-light -mt-1 block text-xs'>
				Lo calculamos con tu CURP, confírmalo
			</span>
		);
	}
	return null;
};

export default RfcPrefillHint;
